import { Injectable } from '@angular/core';
import { TrackingService } from '../shared/services/tracking.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {TrackingCategory, TrackingAction} from '../shared/model/tracking/tracking.enum';


@Injectable()
export class RattachementService {

    constructor(private trackingService: TrackingService, private http: HttpClient) {

    }

    applyRattachement(secretCode: string): Observable<any> {
        return this.http.post('/api/requetes/rejoindre-dossier/', secretCode);
    }

    trackCguEvent(action: TrackingAction) {
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Acceptation CGU'
            }
        });
    }

    trackRattachementSucceedEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.SUCCESS,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Rattachement effectué'
            }
        });
    }

    trackRattachementFailedTrTechnicalEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Erreur technique (origine TR)'
            }
        });
    }

    trackRattachementFailedTechnicalEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Erreur technique'
            }
        });
    }

    trackRattachementFailedSyntaxEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Code invalide syntaxiquement (interne TRC)'
            }
        });
    }

    trackRattachementFailedSemanticEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Code invalide semantiquement (validation par TR)'
            }
        });
    }

    trackRattachementFailedAlreadyAttachedEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Code déja utilisé'
            }
        });
    }

    trackRattachementFailedExpiredEvent() {
        this.trackingService.trackEvent({
            action: TrackingAction.FAILED,
            properties: {
                category: TrackingCategory.RATACHEMENT,
                name: 'Code expiré'
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/rattachement.service.ts